module.exports = __webpack_public_path__ + "img/055.f5b616fc.png";